import { useQuery } from '@tanstack/react-query'
import React from 'react'
import * as R from 'remeda'

import { type SurveyFilterInformation_MainQuery as Data } from '~/gql/graphql'
import { exists, filterExists } from '~/utils'

import { useMainQueryKey } from './useMainQueryKey'

export const useMainQueryData = () => {
  const queryKey = useMainQueryKey()

  const { data } = useQuery<Data>({ enabled: false, queryKey })

  return React.useMemo(() => {
    const survey = data?.survey

    if (!exists(survey)) {
      return null
    }

    return R.pipe(survey, (survey) => ({
      ...survey,
      brandGroups: R.pipe(
        survey.brandGroups,
        filterExists,
        R.filter((brandGroup) => exists(brandGroup.mappedAt)),
        R.map((brandGroup) => ({
          ...brandGroup,
          brands: R.pipe(brandGroup.brands, filterExists),
        })),
      ),
      customerAttributeGroups: R.pipe(
        survey.customerAttributeGroups ?? [],
        R.map((customerAttributeGroup) => ({
          ...customerAttributeGroup,
          customerAttributes: customerAttributeGroup.customerAttributes ?? [],
        })),
      ),
      questions: R.pipe(survey.questions, filterExists),
    }))
  }, [data])
}
